export default "__VITE_ASSET__Cp2bnsZ3__"